import { render, staticRenderFns } from "./PlayerRecords.vue?vue&type=template&id=2bdcc351&scoped=true&"
import script from "./PlayerRecords.vue?vue&type=script&lang=js&"
export * from "./PlayerRecords.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRecords.vue?vue&type=style&index=0&id=2bdcc351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdcc351",
  null
  
)

export default component.exports